import { useState } from "react";

const HUBSPOT_PORTAL_ID = "9161697";
const HUBSPOT_FORM_ID = "a080248a-fad5-4e84-a0ed-e74f5e8496ec";
const HUBSPOT_API = `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${HUBSPOT_FORM_ID}`;

/**
 * Blog sidebar newsletter widget.
 * Matches Hugo: partials/newsletter-blog.html
 * Green gradient card with heading, copy, email form.
 */
export function BlogNewsletterSidebar() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || submitting) return;
    setSubmitting(true);
    try {
      const res = await fetch(HUBSPOT_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fields: [{ name: "email", value: email }],
          context: {
            pageUri: typeof window !== "undefined" ? window.location.href : "",
            pageName:
              typeof document !== "undefined" ? document.title : "",
          },
        }),
      });
      if (res.ok) setSubmitted(true);
    } catch {
      /* swallow */
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="relative flex flex-col rounded-20 bg-teal-dark text-center">
      <div className="px-4 pb-8 pt-5">
        <img
          src="/images/newletter-post.png"
          alt=""
          className="mb-2"
          loading="lazy"
        />
        <p className="font-display text-2xl font-bold leading-tight text-white md:text-xl">
          Stay in touch
        </p>
        <p className="mt-2 font-body leading-snug text-white/70 md:text-sm">
          The best way to keep up with identity security tips, guides, and
          industry best practices.
        </p>
        {submitted ? (
          <p className="mt-5 font-body text-sm font-medium text-white">
            Thanks! We&apos;ll be in touch.
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="mt-5 space-y-4 lg:mt-5">
            <label className="block w-full">
              <span className="sr-only">Email</span>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email here"
                required
                className="w-full rounded-10 border border-white/20 bg-white/10 px-4 py-2.5 text-center font-body text-base text-white placeholder:text-white/50 focus:border-white/40 focus:outline-none md:py-2 md:text-sm"
              />
            </label>
            <button
              type="submit"
              disabled={submitting}
              className="w-full rounded-10 bg-cream py-2.5 font-body font-medium text-dark hover:bg-white disabled:opacity-50 md:py-1 md:text-base"
            >
              {submitting ? "..." : "Submit"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
